import { roundNumber } from "@endgame/utils/roundNumber";

const defaultRootEMSize = 16;

export const fontValToPx = (value: number) => `${roundNumber(value, 5)}px`;

export const fontValToRem = (value: number) =>
  `${roundNumber(value / defaultRootEMSize, 5)}rem`;
